import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    user: {},
    token: '',
    ifCompose: false,// 当前编辑状态
    patient: {},
    bmiInfo: {},
    systemInfo: {},
    ifShowZiwai: false,
    defaultPage:'/main/home'// 脉图拍摄返回默认页面
  },

  mutations: {
    updateUser(state, data) {
      state.user = data;
      localStorage.setItem('user', JSON.stringify(data));
    },
    updateToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    updateIfCompose(state, ifCompose) {
      state.ifCompose = ifCompose;
    },
    updatePatient(state, data) {
      state.patient = data;
    },
    updateBmi(state, data) {
      state.bmiInfo = data;
    },
    updateSystemInfo(state, data) {
      state.systemInfo = data;
    },
    updateIfShowZiwai(state, data) {
      state.ifShowZiwai = data;
    },
  }
});

export default store;
